import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PrefixSuffixPipe } from './pipes/prefix-suffix.pipe';
import { EmptyCheckPipe } from './pipes/emptyCheck.pipe';
import { DatePipe, DecimalPipe } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HideTextPipe } from './pipes/hide-text.pipe';
import { DateRangePipe } from './pipes/dateRange.pipe';


@NgModule({
  declarations: [
    PrefixSuffixPipe,
    EmptyCheckPipe,
    DateRangePipe,
    HideTextPipe
  ],
  imports: [
    NgxSpinnerModule
  ],
  exports: [
    TranslateModule,
    PrefixSuffixPipe,
    EmptyCheckPipe,
    NgxSpinnerModule,
    DateRangePipe,
    HideTextPipe
  ],
  providers: [
    TranslateModule,
    TranslatePipe,
    DecimalPipe,
    DatePipe
  ]
})
export class SharedModule { }